export const displayXML = (rawXML: any) => {
  if (rawXML) {
    const blob = new Blob([rawXML], { type: "text/xml" });
    const url = URL.createObjectURL(blob);
    window.open(url);
    URL.revokeObjectURL(url);
  }
};
